export const getInitialFormValues = () => ({
  cstNm: '',
  prjTyp: '',
  prjImpt: '',
  bugetYn: '',
  partnerTyp: '',
  clientTyp: '',
  incClientTyp: '',
  procurement: '',
  customerCf: '',
  salesTyp: '',
  forcastTxt: '',
  productYn: '',
  clientCmp: '',
  clientCmpNm: '',
  vendorCmp: '',
  vendorCmpNm: '',
  expDay: '',
  crtUsr:  '',
  crtNm: '',
  invoiceToBe: {
    prjUuid: '',
    contractStDt: '',
    contractEdDt: '',
    inspectYn: '',
    invTo: '',
    invMonth: '',
    invDay: '',
    colTo: '',
    colMonth: '',
    colDay: '',
    lockYn: '',
    dateSchedules: '',
  },
  costCalcs: [],
});
